<template>
	<div>
		<navTitle ><div class="pageTitle">筛选会员</div></navTitle>
		<div class="tips">
			您可以通过以下条件进行匹配筛选，查找您想要找的管弦乐会员。
		</div>
		<div class="searchList">
			<div class="searchList-title">您想要查找哪个城市</div>
			<div @click="areaPicker = true" class="searchList-col flex flex-align-center flex-jus-between">
				<div v-if="!reqData.city">所有城市</div>
				<div class="search-val" v-else>{{reqData.city}}</div>
				<img src="@/static/images/icon-arrowRight.png" class="arrow">
			</div>
			<div class="searchList-title">领域人才</div>
			<div @click="professionPopShow = true" class="searchList-col flex flex-align-center flex-jus-between">
				<div v-if="!reqData.major_id">所有领域</div>
				<div class="search-val" v-else>{{major_name}}</div>
				<img src="@/static/images/icon-arrowRight.png" class="arrow">
			</div>
			<div class="searchList-title">会内身份</div>
			<div @click="identityPopShow = true" class="searchList-col flex flex-align-center flex-jus-between">
				<div v-if="!reqData.identity_id">所有身份</div>
				<div class="search-val" v-else>{{identity_text}}</div>
				<img src="@/static/images/icon-arrowRight.png" class="arrow">
			</div>
			<div class="searchList-title">认证搜索</div>
			<div @click="typePopShow=true" class="searchList-col flex flex-align-center flex-jus-between">
				<div v-if="!reqData.authentication">所有认证</div>
				<div class="search-val" v-else>{{typeText}}</div>
				<img src="@/static/images/icon-arrowRight.png" class="arrow">
			</div>
			
			<div class="searchList-confirm" @click="searchOk">确定</div>
		</div>
		<!-- 地区弹窗 -->
		<van-popup v-model="areaPicker" round position="bottom"><van-area title="请选择" :area-list="areaList" @cancel="areaPicker = false" @confirm="areaConfirm" /></van-popup>
		<!-- 专业领域弹窗 -->
		<van-popup v-model="professionPopShow" round position="bottom" :safe-area-inset-bottom="true">
			<div class="professionPop">
				<div class="title flex flex-align-center ">
					<div class="title-cancel" @click="professionPopShow = false">取消</div>
					<div class="title-content flex-1">请选择专业领域</div>
					<div class="title-confirm" @click="confirmPro">确定</div>
				</div>

				<div class="selectList flex flex-wrap flex-align-center">
					<div class="item" v-for="(item, index) in majorList" :key="index" @click="proSelec(item)" :class="{ 'item-active': reqData.major_id == item.id }">{{ item.name }}</div>
				</div>
			</div>
		</van-popup>
		<!-- 认证搜索 -->
		<van-popup v-model="identityPopShow" round position="bottom">
			<van-picker
				title="选择身份"
				show-toolbar
				:columns="identityList"
				@confirm="onIdentityConfirm"
				@cancel="onIdentityCancel"
			/>
		</van-popup>
		<!-- 认证搜索 -->
		<van-popup v-model="typePopShow" round position="bottom">
			<van-picker
				title="选择认证"
				show-toolbar
				:columns="typeList"
				@confirm="onTypeConfirm"
				@cancel="onTypeCancel"
			/>
		</van-popup>
	</div>
</template>

<script>
	/* eslint-disable */
	// import areaList from '../../area.js';
	import {mapState} from 'vuex'
	export default {
		watch: {
		},
		data() {
			return{
				reqData: {
					initials: '',
					city: '',
					major_id: '',
					identity_id: '',
					authentication: ''
				},
				// 地区弹窗
				areaPicker: false,
				areaList: {
					province_list: {
						350000: '福建省',
					},
					city_list: {
						350100: '福州市',
						350200: '厦门市',
						350300: '莆田市',
						350400: '三明市',
						350500: '泉州市',
						350600: '漳州市',
						350700: '南平市',
						350800: '龙岩市',
						350900: '宁德市',
					}
				},
				province: '',

				// 专业领域
				professionPopShow: false,
				major_name: '',

				// 会员身份
				identityPopShow: false,
				identityList: [],
				identity_text: '',

				typePopShow: false,
				typeText: '',
				typeList: [
					{
						id: '1',
						text: '认证名师'
					},
					{
						id: '2',
						text: '认证考官'
					}
				]
			}
		},
		computed: {
			...mapState(['majorList'])
		},
		created() {
			this.getIdentity()
		},
		mounted() {
			this.$wx.ready(() => {
				this.$wx.updateAppMessageShareData({
					title: '福建省民族管弦乐学会',
					desc: '福建省民族管弦乐学会',
					link: location.href,
					imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
				})
				this.$wx.updateTimelineShareData({
					title: '福建省民族管弦乐学会',
					link: location.href,
					imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
				})
			});
		},
		methods: {
			// 地区 确认
			areaConfirm(e) {
				this.province = e[0].name
				this.reqData.city = e[1].name
				this.areaPicker = false
			},
			// 专业领域 确认
			confirmPro() {
				this.professionPopShow = false;
			},
			proSelec(data) {
				this.reqData.major_id = data.id
				this.major_name = data.name
			},
			onIdentityConfirm(e) {
				this.reqData.identity_id = e.id
				this.identity_text = e.text
				this.identityPopShow = false
			},
			onIdentityCancel() {
				this.identityPopShow = false
			},
			// 获取会员身份
			getIdentity() {
				this.$get('api/user/getIdentity').then(res => {
					this.identityList = res.data.map(item => {
						return {
							id: item.id,
							text: item.name
						}
					})
				})
			},
			onTypeConfirm(e) {
				this.reqData.authentication = e.id
				this.typeText = e.text
				this.typePopShow = false
			},
			onTypeCancel() {
				this.typePopShow = false
			},
			searchOk() {
				this.$router.push({'name': 'member_results', query: {
					reqData: JSON.stringify(this.reqData),
					province: this.province,
					major_name: this.major_name,
					identity_text: this.identity_text
				}})
			}
		}
	}
</script>

<style scoped lang="stylus">
// 专业领域的弹窗
.professionPop
	padding 44px 30px
	.title
		.title-cancel
			font-size 30px
			color #000000
		.title-content
			font-size 34px
			font-weight bold
			color #0A0A0A
			text-align center
		.title-confirm
			font-size 30px
			font-weight bold
			color #DE113C
	.tips
		width 100%
		text-align center
		margin-top 24px
		font-size 24px
		font-weight 500
		color #B1B1B1
	.selectList
		.item
			margin-top 40px
			margin-right 10px
			width 160px
			height 60px
			line-height 60px
			background #FFFFFF
			border 2px solid #B1B1B1
			border-radius 38px
			font-size 28px
			color #000000
			text-align center
		.item-active
			background #FFD6DF !important
			border 2px solid #DE113C !important
			color #DE113C !important
.tips
	padding 14px 30px
	background: #F6F6F6;
	font-size: 24px;
	color: #888888;
.searchList
	padding 24px 30px 60px 30px
	.searchList-title
		font-size: 30px;
		font-weight: bold;
		color: #000000;
		margin-bottom 28px
	.searchList-col
		width 100%
		padding 24px 16px 24px 24px
		border: 2px solid #F6F6F6;
		border-radius: 10px;
		font-size: 26px;
		color: #B1B1B1;
		margin-bottom 40px
		.arrow
			width 14px
			height 26px
		.search-val
			color #000
	.searchList-confirm
		width 376px
		height 92px
		line-height 92px
		text-align center
		background-image url('~@/static/images/index/btnBG.png')
		background-size 100% 100%
		background-position center
		font-size: 32px;
		color: #FFFFFF;
		margin 0 auto
</style>
